module.exports = __webpack_public_path__ + "static/1360340739.f29c5235.jpg";